import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  fetchAdministrationData,
  fetchBookkeepingSettings,
  fetchVATOptions,
} from '../../../../actions/administration/administration-actions';
import AdministrationBookkeepingPopup from './AdministrationBookkeepingPopup';
import { LOCAL_STORAGE_MACHINE_ID } from '../../../../actions/auth-actions';
import AdministrationBookkeepingForm from './AdministrationBookkeepingForm';
import AdministrationBookkeepingContent from './AdministrationBookkeepingContent';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  mainHeader: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
}));

const AdministrationBookkeeping = ({
                                     machines,
                                     vatOptions,
                                     fetchVATOptions,
                                     fetchAdministrationData,
                                     fetchBookkeepingSettings,
                                   }) => {
  const masterMachines = machines.filter(machine => machine.IsSyncMachine);
  const machinesOptions = masterMachines.map(machine => ({ label: machine.Name, value: machine.Id }));
  const [machineId, setMachineId] = useState(localStorage.getItem(LOCAL_STORAGE_MACHINE_ID) || machinesOptions[0]?.value);
  const selectedMachineLabel = machinesOptions.find(option => option.value === machineId)?.label;
  const [activePopup, setPopupActive] = useState(false);
  const [isDirty, setDirty] = useState(false);
  const { formatMessage } = useIntl();
  const classes = useStyles();
  
  React.useEffect(() => {
    if (!vatOptions) fetchVATOptions();
  }, [fetchVATOptions, vatOptions]);
  
  React.useEffect(() => {
    fetchAdministrationData('Category', machineId, { text: null }, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchAdministrationData]);
  
  const handleMachineIdChange = ({ target: { value: newMachineId } }) => {
    setMachineId(newMachineId);
    localStorage.setItem(LOCAL_STORAGE_MACHINE_ID, newMachineId);
  };
  
  return (
    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
      <h1 className={classes.mainHeader}>Bookkeeping accounts</h1>
  
      <AdministrationBookkeepingForm
        machineId={machineId}
        machinesOptions={machinesOptions}
        handleMachineIdChange={handleMachineIdChange}
        fetchBookkeepingSettings={fetchBookkeepingSettings}
      />
      
      <AdministrationBookkeepingContent
        machineId={machineId}
        setPopupActive={setPopupActive}
        fetchAdministrationData={fetchAdministrationData}
        setDirty={setDirty}
        readOnly={true}
      />
  
      <AdministrationBookkeepingPopup
        machineId={machineId}
        selectedMachineLabel={selectedMachineLabel}
        vatOptions={vatOptions}
        activePopup={activePopup}
        setPopupActive={setPopupActive}
      />
  
      <Prompt
        when={isDirty}
        message={() => formatMessage({
          id: 'confirmation.prompt',
          defaultMessage: 'Are you sure you want to leave without saving?',
        })}
      />
    </Box>
  );
};

AdministrationBookkeeping.propTypes = {
  machines: PropTypes.array,
  vatOptions: PropTypes.array,
  fetchVATOptions: PropTypes.func,
  fetchAdministrationData: PropTypes.func,
  fetchBookkeepingSettings: PropTypes.func,
};

const decorate = compose(
  connect(store => ({
      machines: store.user.machines,
      vatOptions: store.administrationData.vatOptions,
    }),
    dispatch => bindActionCreators({ fetchVATOptions, fetchAdministrationData, fetchBookkeepingSettings }, dispatch),
  ),
);

export default decorate(AdministrationBookkeeping);